module.exports = __webpack_public_path__ + "static/media/largo-subcapital.592e3935.png";